import React from 'react';
import AddToCartBtn from './AddToCartBtn';
import { useTranslation } from 'Shared/Hooks/useTranslation';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';
import locales from '../../i18n/localeEs';

const translations = locales.es;

type PurchaseButtonsTypes = {
  canRenderAddToCartButton?: boolean;
  courseId: number;
  courseType: string;
  fromSticky?: boolean;
  buyCourse(): void;
  addToCartTheme?: 'a' | 'b';
};

const PurchaseButtons: React.FC<PurchaseButtonsTypes> = ({
  canRenderAddToCartButton,
  courseId,
  courseType,
  fromSticky,
  buyCourse,
  addToCartTheme = 'a',
}) => {
  const { t } = useTranslation();

  if (courseType === 'membership') {
    return (
      <a href="/membresias/" className="mt-16 ml-auto mr-auto w-full sm:w-auto">
        <PrimaryButton
          full
          label={t('TURN_PREMIUM', {
            defaultValue: translations.TURN_PREMIUM,
          })}
          className="mt-24"
        />
      </a>
    );
  }

  if (addToCartTheme === 'b') {
    return (
      <div className="sm:flex sm:flex-row w-full md:block">
        <PrimaryButton
          className="w-full mb-16 sm:mb-0 sm:mr-8 md:mr-0 md:mb-16 "
          label={t('BUY_NOW', {
            defaultValue: translations.BUY_NOW,
          })}
          onClick={buyCourse}
          size="l"
        />
        {canRenderAddToCartButton && (
          <div className="w-full sm:ml-8 md:ml-0">
            <AddToCartBtn
              courseId={courseId}
              fromSticky={fromSticky}
              addToCartTheme={addToCartTheme}
              size="l"
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`${fromSticky ? 'flex flex-row-reverse w-full' : ''}`}>
      <PrimaryButton
        className={`${!fromSticky ? 'mb-16' : ''} ml-auto mr-auto w-full`}
        full
        label={t('BUY_NOW', {
          defaultValue: translations.BUY_NOW,
        })}
        onClick={buyCourse}
      />
      {canRenderAddToCartButton && (
        <div className={`${!fromSticky && 'w-full'}`}>
          <AddToCartBtn
            courseId={courseId}
            fromSticky={fromSticky}
            addToCartTheme={addToCartTheme}
          />
        </div>
      )}
    </div>
  );
};

export default PurchaseButtons;
